<div class="loader color-{{ color }}">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
